export default "__VITE_ASSET__DYQu7NaB__"